import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-thurston',
  templateUrl: './windev.component.html',
  styleUrls: ['./windev.component.css']
})
export class WindevComponent implements OnInit{

  constructor() { }

  ngOnInit(): void {
  }

}
